import React from 'react';
import { useHistory } from 'react-router-dom';

import CaseIcon from '../../assets/icons/CaseIcon';

import CasesTableContainer from '../cases/CasesTableContainer';
import AddButton from '../shared/AddButton';

import routes from '../../constants/routes';

import './home.scss';

const DashboardCasesTable = (props) => {
  const { cases, surgeons, hospitals, procedures, isLoaded } = props;
  const history = useHistory();

  return (
    <div className='cases-table__container'>
      <div className='d-flex m-b-lg space-between'>
        <div className='d-flex'>
          <CaseIcon color='var(--app-text)' />
          <div className='font-size-bg font-bold m-l-md'>
            Upcoming Cases
          </div>
        </div>

        <AddButton onClick={() => history.push(routes.CASES)} />
      </div>
      <CasesTableContainer
        cases={cases}
        surgeons={surgeons}
        hospitals={hospitals}
        procedures={procedures}
        withoutCheck
        rowColor='var(--app-table-row)'
        rowBorderColor='transparent'
        onSelectCase={(item) => history.push(`${routes.CASES}/${item.caseId}`)}
        checkboxes={false}
        loading={!isLoaded}
      />
    </div>
  );
};

export default DashboardCasesTable;
